// File: components/renderer/allies/drawZoey.ts
import { Ally } from "../../types/entities";
import { drawHighFidelityFace } from "../utils";
import { CostumeId } from "../../../types";

// --- WEAPON RENDERER ---
const drawShinkal = (ctx: CanvasRenderingContext2D, isLeft: boolean) => {
    ctx.save();
    const fanAngle = isLeft ? -0.5 : 0.5;
    ctx.rotate(fanAngle);
    const drawBlade = (rotation: number) => {
        ctx.save();
        ctx.rotate(rotation);
        ctx.fillStyle = "#ffd700";
        ctx.beginPath(); ctx.roundRect(-2, 0, 4, 12, 1); ctx.fill();
        ctx.fillStyle = "#00ffff";
        ctx.beginPath(); ctx.arc(0, 6, 1.5, 0, Math.PI * 2); ctx.fill();
        ctx.strokeStyle = "#ff00ff"; ctx.lineWidth = 1;
        ctx.beginPath(); ctx.moveTo(0, 12); ctx.quadraticCurveTo(isLeft ? 5 : -5, 20, 0, 25); ctx.stroke();
        ctx.translate(0, -2);
        const bladeGrad = ctx.createLinearGradient(0, 0, 0, -35);
        bladeGrad.addColorStop(0, "rgba(0, 255, 255, 0.8)");
        bladeGrad.addColorStop(1, "rgba(255, 255, 255, 0.4)");
        ctx.fillStyle = bladeGrad;
        ctx.shadowColor = "#00ffff"; ctx.shadowBlur = 5;
        ctx.beginPath();
        ctx.moveTo(-3, 0);
        ctx.quadraticCurveTo(-4, -15, 0, -35);
        ctx.quadraticCurveTo(4, -15, 3, 0);
        ctx.fill();
        ctx.strokeStyle = "rgba(255,255,255,0.7)"; ctx.lineWidth = 0.5; ctx.shadowBlur = 0;
        ctx.beginPath(); ctx.moveTo(0, -5); ctx.lineTo(0, -25); ctx.stroke();
        ctx.restore();
    };
    drawBlade(-0.3); drawBlade(0); drawBlade(0.3);
    ctx.restore();
};

export const drawZoey = (ctx: CanvasRenderingContext2D, zoey: Ally, costume: CostumeId = 'DEFAULT', hideWeapon: boolean = false) => {
    ctx.save();
    ctx.translate(zoey.x + zoey.width / 2, zoey.y + zoey.height);
    const scale = zoey.height / 180;
    ctx.scale(scale, scale);
    const bob = Math.sin(Date.now() / 200) * 2;
    ctx.translate(0, bob);
    const SKIN_TONE = "#f2d6b5";
    const skinGrad = ctx.createLinearGradient(0, -180, 0, 0);
    skinGrad.addColorStop(0, "#f5e2d1"); skinGrad.addColorStop(1, "#d1b392");

    ctx.save(); ctx.translate(0, -148); ctx.fillStyle = skinGrad; ctx.fillRect(-4, -5, 8, 10); ctx.restore();

    if (costume === 'DEFAULT') {
        ctx.fillStyle = skinGrad;
        ctx.beginPath(); ctx.moveTo(-15, -145); ctx.lineTo(15, -145); ctx.lineTo(12, -85); ctx.lineTo(-12, -85); ctx.closePath(); ctx.fill();
        ctx.fillStyle = "#111827";
        ctx.beginPath(); ctx.moveTo(-5, -85); ctx.quadraticCurveTo(-25, -60, -20, -10); ctx.lineTo(-6, -10); ctx.lineTo(-2, -85); ctx.fill();
        ctx.beginPath(); ctx.moveTo(5, -85); ctx.quadraticCurveTo(25, -60, 20, -10); ctx.lineTo(6, -10); ctx.lineTo(2, -85); ctx.fill();
        ctx.fillStyle = "#facc15"; ctx.beginPath(); ctx.roundRect(-22, -55, 10, 25, 2); ctx.fill();
        ctx.beginPath(); ctx.roundRect(12, -45, 10, 20, 2); ctx.fill();
        ctx.fillStyle = "#059669";
        ctx.beginPath(); ctx.roundRect(-16, -135, 32, 28, 2); ctx.fill();
    }
    else if (costume === 'PAJAMAS') {
        ctx.fillStyle = "#9b59b6";
        ctx.beginPath(); ctx.roundRect(-15, -150, 30, 60, 4); ctx.fill();
        ctx.beginPath(); ctx.moveTo(-12, -90); ctx.lineTo(12, -90); ctx.lineTo(10, 0); ctx.lineTo(-10, 0); ctx.fill();
    }
    else if (costume === 'LEATHER') {
        ctx.fillStyle = "#111";
        ctx.beginPath(); ctx.moveTo(-10, -90); ctx.lineTo(-15, 0); ctx.lineTo(15, 0); ctx.lineTo(10, -90); ctx.fill();
        ctx.fillRect(-15, -150, 30, 60);
        ctx.fillStyle = "rgba(255,255,255,0.2)";
        ctx.beginPath(); ctx.moveTo(-15, -150); ctx.lineTo(-5, -150); ctx.lineTo(-10, -90); ctx.fill();
    }
    else if (costume === 'HANBOK') {
        ctx.fillStyle = "#1e293b"; // Chima (Skirt)
        ctx.beginPath();
        ctx.moveTo(0, -90); ctx.lineTo(-35, 0); ctx.lineTo(35, 0); ctx.closePath();
        ctx.fill();

        ctx.strokeStyle = "#00ffff"; // Skirt Trim
        ctx.lineWidth = 2;
        ctx.shadowColor = "#00ffff"; ctx.shadowBlur = 10;
        ctx.beginPath(); ctx.moveTo(-35, 0); ctx.lineTo(35, 0); ctx.stroke();
        ctx.shadowBlur = 0;

        ctx.fillStyle = "#0f172a"; // Jeogori (Top)
        ctx.fillRect(-18, -145, 36, 55);

        ctx.fillStyle = "#00ffff"; // Goreum (Ribbon)
        ctx.fillRect(-3, -135, 6, 25);
        ctx.beginPath();
        ctx.moveTo(-3, -115); ctx.lineTo(-15, -100); ctx.lineTo(-12, -110);
        ctx.moveTo(3, -115); ctx.lineTo(15, -100); ctx.lineTo(12, -110);
        ctx.fill();

        ctx.fillStyle = skinGrad;
        ctx.fillRect(-8, -5, 16, 10);
    }

    ctx.save();
    const armColor = (costume === 'PAJAMAS') ? "#9b59b6" : skinGrad;
    ctx.fillStyle = armColor;
    let armRotLeft = -0.4; let armRotRight = 0.4; let armOffsetY = 50;
    if (zoey.isAttacking) { armRotLeft = -2.5; armRotRight = 2.5; armOffsetY = 50; }
    ctx.save(); ctx.translate(-15, -145); ctx.rotate(armRotLeft); ctx.beginPath(); ctx.roundRect(-6, 0, 12, 50, 4); ctx.fill(); if (!hideWeapon) { ctx.translate(0, armOffsetY); drawShinkal(ctx, true); } ctx.restore();
    ctx.save(); ctx.translate(15, -145); ctx.rotate(armRotRight); ctx.beginPath(); ctx.roundRect(-6, 0, 12, 50, 4); ctx.fill(); if (!hideWeapon) { ctx.translate(0, armOffsetY); drawShinkal(ctx, false); } ctx.restore();
    ctx.restore();

    ctx.save();
    ctx.translate(0, -148);
    const hairGrad = ctx.createLinearGradient(0, -50, 0, -20);
    hairGrad.addColorStop(0, "#333"); hairGrad.addColorStop(1, "#000");
    // LIGHT BROWN EYES
    drawHighFidelityFace(ctx, skinGrad, "#7a4d3a", hairGrad);
    // SPARKLY MAKEUP
    ctx.fillStyle = "#fff"; ctx.globalAlpha = 0.6;
    for (let i = 0; i < 3; i++) { ctx.beginPath(); ctx.arc(-13 + i * 2, -22 + (i % 2), 0.5, 0, Math.PI * 2); ctx.fill(); ctx.beginPath(); ctx.arc(13 - i * 2, -22 + (i % 2), 0.5, 0, Math.PI * 2); ctx.fill(); }
    ctx.globalAlpha = 1.0;
    // FRECKLES
    ctx.fillStyle = "rgba(139, 69, 19, 0.4)";
    const drawFreckle = (fx: number, fy: number) => { ctx.beginPath(); ctx.arc(fx, fy, 0.5, 0, Math.PI * 2); ctx.fill(); };
    drawFreckle(-8, -12); drawFreckle(-10, -13); drawFreckle(-9, -15); drawFreckle(8, -12); drawFreckle(10, -13); drawFreckle(9, -15);
    // HEART SHAPED MOUTH
    if (zoey.isAttacking) {
        ctx.save(); ctx.translate(0, -6); ctx.scale(0.8, 0.8); ctx.fillStyle = "#e11d48"; ctx.beginPath(); ctx.moveTo(0, 0); ctx.bezierCurveTo(-4, -4, -8, 0, 0, 6); ctx.bezierCurveTo(8, 0, 4, -4, 0, 0); ctx.fill(); ctx.restore();
    }
    if (zoey.isAttacking) ctx.translate(0, -5);
    ctx.fillStyle = hairGrad;
    ctx.beginPath(); ctx.moveTo(-15, -38); ctx.quadraticCurveTo(-20, -25, -10, -20); ctx.lineTo(-5, -45); ctx.fill();
    ctx.beginPath(); ctx.moveTo(15, -38); ctx.quadraticCurveTo(20, -25, 10, -20); ctx.lineTo(5, -45); ctx.fill();
    ctx.restore();
    ctx.restore();
};